import React from 'react'
import { makeStyles } from '@mui/styles'
import lang from '@/lang'
import GeneralTaxSettings from '@/modules/settings/components/tax-settings/general/general-tax-settings'
import FiscalYear from '@/modules/settings/components/fiscal-year'
import { Title } from '@/modules/base/components/texts/index'
import HorizontalRuler from '@/modules/base/components/ruler/horizontal-ruler'
import IconTaxSetting from '@assets/images/icons/paper_settings.svg'
import TaxInfo from '@/modules/company/taxInfo'
import PropTypes from 'prop-types'
import GrossNetSwitchWrapper from '@/modules/settings/components/tax-settings/gross-net-switch-wrapper'
import GrossNetSwitch from '@/modules/settings/components/tax-settings/gross-net-switch'

const useStyles = makeStyles(() => ({
  container: {
    paddingBottom: 30,
  },
  titleClass: {
    margin: '0px auto 30px 0px',
  },
}))

const AccountTaxSettings = ({
  onSetScrollLock = () => {},
  onSave,
  refresh = false,
  client,
}) => {
  const classes = useStyles()

  return (
    <div className={classes.container}>
      <Title icon={IconTaxSetting} className={classes.titleClass} size='small20'>{lang.myAccount.informationBoxSettings.tax.headline}</Title>
      <TaxInfo onSetScrollLock={onSetScrollLock} client={client} />
      <HorizontalRuler />
      <GeneralTaxSettings refresh={refresh} onSave={onSave} />
      <HorizontalRuler />
      <FiscalYear refresh={refresh} onSave={onSave} />
      <HorizontalRuler />
      {client
        ? (
          <GrossNetSwitchWrapper />
        )
        : (
          <GrossNetSwitch />
        )}
    </div>
  )
}

AccountTaxSettings.propTypes = {
  onSetScrollLock: PropTypes.func,
  refresh: PropTypes.bool,
}

export default AccountTaxSettings
